import { on as onEvent } from "common/utils/ui/event";
import "./checkout-order-details.scss";
import "components/jiffy/order-line-item/order-line-item";
import showConfirmation from "components/kit/confirmation_modal/component";

document.addEventListener("DOMContentLoaded", () => {
  onEvent("click", ".js-checkout-order-details-confirm-transition", async (e, $target) => {
    e.preventDefault();

    const { result } = await showConfirmation();

    if (result) {
      window.location.href = $target.href;
    }
  });
});
